var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXrp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6273 24 24 18.6273 24 12C24 5.37269 18.6273 0 12 0C5.37269 0 0 5.37269 0 12C0 18.6273 5.37269 24 12 24Z",
    fill: "#FFFDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1174 6H19.2134L14.8529 10.3153C13.2744 11.8775 10.7155 11.8775 9.13703 10.3153L4.77676 6H6.87248L10.185 9.27834C10.6676 9.7536 11.3177 10.02 11.995 10.02C12.6722 10.02 13.3224 9.7536 13.8049 9.27834L17.1174 6ZM6.84572 18H4.75L9.13731 13.6579C10.7158 12.0957 13.2747 12.0957 14.8532 13.6579L19.2405 18H17.1448L13.8052 14.6952C13.3226 14.2198 12.6725 13.9534 11.9951 13.9534C11.3178 13.9534 10.6676 14.2198 10.185 14.6952L6.84572 18Z",
    fill: "#23292F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.2174C18.1953 23.2174 23.2174 18.1952 23.2174 12C23.2174 5.8048 18.1953 0.782621 12 0.782621C5.8048 0.782621 0.78262 5.8048 0.78262 12C0.78262 18.1952 5.8048 23.2174 12 23.2174ZM12 24C18.6273 24 24 18.6274 24 12C24 5.37258 18.6273 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#191326"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.7fbdf2b1635fb7b73a849b2d2ea99fb9.svg";
export { ForwardRef as ReactComponent };